import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=5547ec69&"
import script from "./Version.vue?vue&type=script&lang=ts&"
export * from "./Version.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5547ec69')) {
      api.createRecord('5547ec69', component.options)
    } else {
      api.reload('5547ec69', component.options)
    }
    module.hot.accept("./Version.vue?vue&type=template&id=5547ec69&", function () {
      api.rerender('5547ec69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Version.vue"
export default component.exports